var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ganttRow",staticStyle:{"display":"flex"}},[_c('div',{staticClass:"room-number",style:({
      flex: _vm.dayWidth,
    }),attrs:{"title":_vm.item !== undefined && _vm.item !== null ? _vm.item : '//'}},[_c('span',[_vm._v(_vm._s(_vm.item !== undefined && _vm.item !== null ? _vm.item : "//"))])]),_vm._l((_vm.days),function(day,index){return _c('div',{key:index,ref:`day-${day.date()}`,refInFor:true,staticClass:"day",style:({
      flex: _vm.dayWidth,
    }),attrs:{"data-day":day.toISOString()},on:{"mousedown":function($event){return _vm.startBookCreation(day, $event)}}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }